import { getSolanaConnection } from '../connection';
import { decodeVaultState } from '../decoders/vaultState';
import { getGlobalDumpVaultPda } from '../pdas/globalDumpVault';

export async function fetchGlobalDumpVault() {
  const connection = getSolanaConnection();
  const publicKey = getGlobalDumpVaultPda();
  const accountInfo = await connection.getAccountInfo(publicKey, 'confirmed');

  if (!accountInfo) {
    throw new Error('global_dump_vault account was not found.');
  }

  return {
    publicKey: publicKey.toBase58(),
    lamports: accountInfo.lamports,
    data: decodeVaultState(accountInfo.data),
  };
}
